// components/HonoraireList.js
import { DocumentCheckIcon, InformationCircleIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import EmptyState from "./EmptyState";

function HonoraireList({ honoraires, onDeleteSuccess }) {
  const [deletingId, setDeletingId] = useState(null);
  const [error, setError] = useState(null);


  const handleDelete = async (honoraireId,actionsId) => {
    if (!honoraireId) return;
    setDeletingId(honoraireId);
    setError(null);

    try {
      const url = `https://api.airtable.com/v0/appD48APNaGA4GN0B/honoraires/${honoraireId}`;
      await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
        },
      });

      if (onDeleteSuccess) {
        onDeleteSuccess(); // Appelle le refresh dans le parent

        const url = `https://api.airtable.com/v0/appD48APNaGA4GN0B/actions/${actionsId}`;
      await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
        },
      });
      }

      
    } catch (err) {
      console.error("Erreur suppression :", err);
      setError("Échec de la suppression, réessayez.");
    } finally {
      setDeletingId(null);
    }
  };

  if (!Array.isArray(honoraires) || honoraires.length === 0) {
    return (
      <EmptyState
        icon={InformationCircleIcon}
        title="Aucune demande d'honoraire"
        description="Vous pouvez faire une demande d'honoraire, votre client recevra une demande de paiement avec vos coordonnées bancaire."
      />

    );
  }

  return (
    <ul className="mt-2 divide-y divide-gray-100 overflow-hidden bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl">
      {honoraires.map((hon) => (
        <li key={hon.id} className="relative flex justify-between gap-x-6 p-4 items-center">
          <div className="flex min-w-0 gap-x-4 items-center">
            <DocumentCheckIcon className="text-indigo-600 size-12" />
            <div className="min-w-0 flex-auto">
              <p className="text-sm font-semibold text-gray-900">{hon.fields.type_honoraire}</p>
              <span className="inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-600 ring-1 ring-indigo-500/10 ring-inset">
                Montant : {hon.fields.montant} €
              </span>
              <span className="ml-2 inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-indigo-500/10 ring-inset">
                Demandé le : 
                {new Date(hon.fields.date_ajout).toLocaleString("fr-FR", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
              </span>
            </div>
          </div>
          {hon.fields.statut === "en attente" ? (
            <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-600 ring-1 ring-red-500/10 ring-inset">
              Non payé
            </span>
          ) : (
            <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-600 ring-1 ring-green-500/10 ring-inset">
              Payé
            </span>
          )}
          <div className="flex shrink-0 items-center gap-x-2">
            <a
              href={hon.fields.facture?.[0]?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-md bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-600 hover:bg-indigo-100"
            >
              Voir
            </a>
            <button
              onClick={() => handleDelete(hon.id,hon.actions)}
              disabled={deletingId === hon.id}
              className="rounded-md bg-red-50 px-3 py-2 text-sm font-semibold text-red-600 hover:bg-red-100 flex items-center"
            >
              {deletingId === hon.id ? (
                <>
                  <svg className="animate-spin h-4 w-4 mr-1 text-red-600" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Suppression...
                </>
              ) : (
                <>
                  <TrashIcon className="h-4 w-4 mr-1" /> Supprimer
                </>
              )}
            </button>
          </div>
        </li>
      ))}
      {error && <div className="text-red-600 text-sm mt-2">{error}</div>}
    </ul>
  );
}

export default HonoraireList;